import { Checkbox, Flex, List } from "antd";
import ButtonComponent from "components/button/Button";
import dayjs from "dayjs";
import { xor } from "lodash";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "./styles.scss";

const Helps = ({ data, selected, setSelected }) => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <List
      size="small"
      className="list-help"
      dataSource={data}
      locale={{ emptyText: "データがありません" }}
      renderItem={(item) => (
        <List.Item className="list-help-item">
          <Flex gap="large" wrap="wrap" align="center">
            <Checkbox
              checked={selected?.includes(item?.id)}
              onChange={() => setSelected(xor(selected, [item.id]))}
            />
            <div>
              <div className="help-title">{item.subject}</div>
              <div className="help-content">
                {t("helps.lastEditedDate")}:{" "}
                {item?.last_modified_date
                  ? dayjs(`${item?.last_modified_date} UTC`).format(
                      "YYYY/MM/DD HH:mm"
                    )
                  : ""}{" "}
              </div>
            </div>
          </Flex>
          <ButtonComponent
            background="#0687BB"
            className="preview-button"
            text={t("helps.preview")}
            type="button"
            onClick={() => {
              history.push(`/admin/help-faqs/${item.id}/edit`);
            }}
          />
        </List.Item>
      )}
    />
  );
};

export default Helps;
